import React from 'react';
import { Bar, BarChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import ChartFrame, { TOOLTIP_STYLE } from './ChartFrame';
import { fmtMoney, fmtNumber } from '../derive';
import { EmptyState } from '../states';

const STATUS_COLORS = {
  completed: '#10b981',
  paymentCompleted: '#0ea5e9',
  picked: '#6366f1',
  pending: '#f59e0b',
  requested: '#f43f5e',
  created: '#a1a1aa',
};

// Orders per day for the selected range. Totals live in the KPI bar and the
// status mix lives in the side panel, so this view is just the chart.
export default function CanvasOrders({ series = [], total = 0, revenue = 0, aov = 0, rangeLabel = '' }) {
  const hasSeries = series.some((row) => (row.count || 0) > 0);
  return (
    <ChartFrame
      title="Orders per day"
      subtitle={`Scoped by in-stock date · ${rangeLabel}`}
      right={
        <div className="flex items-center gap-1.5">
          <span className="rounded-md bg-zinc-100 px-1.5 py-0.5 text-[10px] font-semibold tabular-nums text-zinc-700">{fmtNumber(total)} orders</span>
          <span className="rounded-md bg-zinc-100 px-1.5 py-0.5 text-[10px] font-semibold tabular-nums text-zinc-700">{fmtMoney(revenue)}</span>
          <span className="rounded-md bg-zinc-100 px-1.5 py-0.5 text-[10px] font-semibold tabular-nums text-zinc-700">{fmtMoney(aov)} AOV</span>
        </div>
      }
    >
      {hasSeries ? (
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={series} margin={{ top: 8, right: 8, bottom: 0, left: -16 }}>
            <CartesianGrid stroke="#f4f4f5" vertical={false} />
            <XAxis dataKey="label" tick={{ fontSize: 10, fill: '#71717a' }} interval="preserveEnd" />
            <YAxis tick={{ fontSize: 10, fill: '#71717a' }} allowDecimals={false} />
            <Tooltip contentStyle={TOOLTIP_STYLE} cursor={{ fill: 'rgba(99,102,241,0.06)' }} />
            <Bar dataKey="count" name="Orders" fill="#6366f1" radius={[3, 3, 0, 0]} isAnimationActive={false} />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <EmptyState title="No orders in range" description="Try widening the date range or clearing order filters." />
      )}
    </ChartFrame>
  );
}

export { STATUS_COLORS };
